module.exports = __webpack_public_path__ + "img/EN-邀请1.657834bd.png";